export default function trixEditorAttachmentsValidation () {
  window.addEventListener("trix-file-accept", () => {  
    const contentType = ['application/pdf', 'image/png', 'image/gif', 'image/jpeg', 'image/jpg']
    if (!contentType.includes(event.file.type)) {
      event.preventDefault()
      alert("Sorry! Only PDFs and images (png, gif, jpeg & jpg) are allowed.")  
    }
  })
}
